import { useAppDispatch, useAppSelector } from '@verantos-dev/app-state-base';
import { FilterTypeLegacy } from '@verantos-dev/types-cohorts';

import {
  addActiveCohortBuilderItemFilter,
  deleteActiveCohortBuilderItemFilter,
} from '../cohortBuilderSlice';
import { selectActiveCohortBuilderItemNumericFilters } from '../selectors/cohortBuilderEditModalSelectors';

export const useNumericFilters = () => {
  const dispatch = useAppDispatch();

  const numericFilters = useAppSelector(selectActiveCohortBuilderItemNumericFilters) ?? [];

  const onAddNumericFilterClick = () => {
    dispatch(addActiveCohortBuilderItemFilter(FilterTypeLegacy.NUMERIC));
  };

  const onDeleteNumericFilterClick = (id: string) => {
    dispatch(
      deleteActiveCohortBuilderItemFilter({
        filterId: id,
        filterType: FilterTypeLegacy.NUMERIC,
      })
    );
  };

  return {
    numericFilters,
    onAddNumericFilterClick,
    onDeleteNumericFilterClick,
  };
};
